import { AddressModel } from './address.model';
import { BaseModel } from './base.model';
import { CompanyModel } from './company.model';

export class CartModel extends BaseModel {
  // Totals
  discountTotal: number;
  discountTax: number;
  shippingTotal: number;
  shippingTax: number;
  total: number;
  totalTax: number;

  companyId: number | null;
  billingAddressId: number | null;
  shippingAddressId: number | null;

  // Relations
  company: CompanyModel | null;
  billingAddress: AddressModel | null;
  shippingAddress: AddressModel | null;

  constructor(obj?: any) {
    super(obj);

    // Totals
    this.discountTotal = obj?.discountTotal ?? 0;
    this.discountTax = obj?.discountTax ?? 0;
    this.shippingTotal = obj?.shippingTotal ?? 0;
    this.shippingTax = obj?.shippingTax ?? 0;
    this.total = obj?.total ?? 0;
    this.totalTax = obj?.totalTax ?? 0;

    this.companyId = obj?.companyId ?? null;
    this.billingAddressId = obj?.billingAddressId ?? null;
    this.shippingAddressId = obj?.shippingAddressId ?? null;

    // Relations
    this.company = obj?.company ? new CompanyModel(obj.company) : null;
    this.billingAddress = obj?.billingAddress
      ? new AddressModel(obj?.billingAddress)
      : null;
    this.shippingAddress = obj?.shippingAddress
      ? new AddressModel(obj?.shippingAddress)
      : null;
  }

  get subtotal() {
    return this.total - this.totalTax - this.shippingTotal;
  }

  override toForm(): any {
    return {
      notes: '',
      discountTotal: this.discountTotal,
      discountTax: this.discountTax,
      shippingTotal: this.shippingTotal,
      shippingTax: this.shippingTax,
      total: this.total,
      totalTax: this.totalTax,
      billingAddress: this.billingAddress?.toCartForm() || null,
      shippingAddress: this.shippingAddress?.toCartForm() || null,
    };
  }
}
